@let hasError = ngControl.errors && ngControl.touched;
<div
  class="border-input-ring border-input rounded-input bg-primary-on box-border flex w-full text-base focus-within:border-input-focus"
  [ngClass]="{
    'cursor-not-allowed opacity-60': ngControl.control!.disabled,
    'border-input-error': hasError,
  }"
  [ngStyle]="{
    backgroundColor: inputBackground(),
  }">
  <div
    [id]="id() | appendTestId: 'icon-preview'"
    (click)="iconInput.focus()"
    class="flex w-16 cursor-pointer flex-row items-center justify-center bg-transparent px-2">
    <span class="material-symbols-rounded pointer-events-none">
      {{ ngControl.value | toSelectOptionAttribute: name() }}
    </span>
  </div>
  <div class="rounded-input relative w-full rounded-l-none! bg-inherit">
    <input
      [attr.data-bwignore]="ignoreBitwardenAutofill ? 'true' : null"
      #iconInput
      [attr.data-testid]="id() | appendTestId: 'input'"
      autocomplete="off"
      [formControl]="ngControl.control! | toFormControl"
      class="peer p-input w-full border-0 bg-transparent placeholder-transparent focus:border-0 focus:ring-0 focus:outline-none"
      [ngClass]="{
        'cursor-not-allowed': ngControl.disabled,
      }"
      [id]="id()"
      [placeholder]="label() ?? ''"
      type="text" />
    <label
      [attr.data-testid]="id() | appendTestId: 'label'"
      class="peer-placeholder-shown:text-input-label peer-focus:text-input-focus pointer-events-none absolute -top-2 left-4 cursor-text bg-inherit text-sm transition-all peer-placeholder-shown:top-3.5 peer-placeholder-shown:text-base peer-focus:-top-2 peer-focus:text-sm"
      [ngClass]="{ 'text-input-error': hasError }"
      [for]="id()">
      {{ formattedLabel() }}
    </label>
    @if (showList()) {
      <div class="fixed top-0 right-0 bottom-0 left-0 z-10 w-full"></div>
    }
    <div
      tabindex="-1"
      [id]="id() | appendTestId: 'options'"
      [attr.data-testid]="id() | appendTestId: 'options'"
      [ngClass]="{ hidden: !showList() }"
      class="focus:border-input-focus border-input-ring bg-primary-on border-input rounded-input absolute z-10 flex max-h-[300px] w-full flex-row flex-wrap overflow-y-scroll focus:outline-hidden">
      @for (option of filteredOptions(); track $index; let index = $index) {
        <div
          [attr.data-testid]="id() + index | appendTestId: 'option'"
          class="hover:bg-standard-hover-main cursor-pointer p-2"
          [ngClass]="{
            'text-input-focus': selectedItem() === index,
            'rounded-t-lg': index === 0,
            'rounded-b-lg': index === filteredOptions()!.length - 1,
          }"
          (click)="selectOptionAndSetItem(option, index)">
          <span class="material-symbols-rounded">
            {{ option | toSelectOptionAttribute: name() }}
          </span>
        </div>
      }
      @if (filteredOptions()!.length === 0) {
        <div
          class="focus:border-input-focus border-input-ring rounded-input-item border-input absolute z-10 max-h-[300px] w-full overflow-y-scroll focus:outline-hidden"
          [attr.data-testid]="id() | appendTestId: 'option'">
          {{
            textStore.texts()
              | filterTexts: ERelationType.noOptions : EEntityType.generic
              | language
          }}
        </div>
      }
    </div>
  </div>
</div>
@if (hasError && !errorTemplate()) {
  <aw-error-message [attr.data-testid]="id() | appendTestId: 'error'">
    <ng-content></ng-content>
  </aw-error-message>
}
@if (hasError && errorTemplate()) {
  <aw-error-message [attr.data-testid]="id() | appendTestId: 'error'">
    <ng-container *ngTemplateOutlet="errorTemplate()!"></ng-container>
  </aw-error-message>
}
